/**
 * It is in common, cause
 * it is used by recurringService, which is used
 * by make-transfer and scheduled-transfer modules.
 */
export enum RecurringType {
  ENDLESS = 'endless',
  NUMBER = 'number',
  END_DATE = 'end-date',
}
